<template>
  <div class="main">
    <Nav />
    <div class="container">
      <FullCalendar
        defaultView="dayGridMonth"
        :plugins="calendarPlugins"
        :events="schedule"
        @eventClick="eventClickHandler"
      />
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
export default {
  components: {
    FullCalendar,
    Nav,
    Footer
  },
  data() {
    return {
      calendarPlugins: [dayGridPlugin],
      schedule: []
    };
  },
  methods: {
    eventClickHandler: function(event) {
      this.$router.push({
        name: "module",
        params: { id: event.event.id, fromSchedule: true }
      });
    },
    logAction: async function(action, note) {
      const body = {
        action,
        note: JSON.stringify(note)
      };
      const config = this.$store.getters.config;
      await axios.post(`${process.env.VUE_APP_API_URL}log`, body, config);
    }
  },
  mounted() {
    const config = this.$store.getters.config;
    const url = `${process.env.VUE_APP_API_URL}schedule`;
    axios.get(url, config).then(response => {
      this.schedule = response.data.schedule;
      this.logAction("view_schedule", {});
    });
  }
};
</script>

<style lang='scss'>
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
</style>

